module.exports = __webpack_public_path__ + "img/QuilityLogoSymbolWhiteRGB.86d5d510.svg";